import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import 'bootstrap/dist/js/bootstrap.min.js'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'swiper/dist/css/swiper.min.css'
import './index.css'
import './xs_width.css'
import Dashboard from './page/Dashboard.vue'
import Introduction from './page/introduction/Introduction.vue'
import Hope from './page/introduction/Hope.vue'
import Honor from './page/introduction/Honor.vue'
import Internet from './page/content/Internet.vue'
import Idc from './page/content/Idc.vue'
import Ict from './page/content/Ict.vue'
import CDN from './page/content/CDN.vue'
import LoginCdn from './page/LoginCdn.vue'
import Software from './page/content/Software.vue'
import CardNetwork from './page/content/CardNetwork.vue'
import IntegralMall from './page/content/IntegralMall.vue'
import Cloud from './page/case/Cloud.vue'
import Customer from './page/case/Customer.vue'
import Medical from './page/case/Medical.vue'
import ServiceCloud from './page/case/ServiceCloud.vue'
import Tms from './page/case/Tms.vue'
import Contact from './page/Contact.vue'
import Recruit from './page/Recruit.vue'
import NotFound from './components/NotFound.vue'


Vue.config.productionTip = false
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  scrollBehavior: () => ({
    y: 0
  }),
  routes:[
    { path: '/', component: Dashboard },
    { path: '/introduction', component: Introduction },
    { path: '/hope', component: Hope },
    { path: '/honor', component: Honor },
    { path: '/internet', component: Internet },
    { path: '/idc', component: Idc },
    { path: '/ict', component: Ict },
    { path: '/cdn', component: CDN },
    { path: '/loginCdn', component: LoginCdn },
    { path: '/software', component: Software },
    { path: '/cardNetwork', component: CardNetwork },
    { path: '/integralMall', component: IntegralMall },
    { path: '/cloud', component: Cloud },
    { path: '/customer', component: Customer },
    { path: '/medical', component: Medical },
    { path: '/serviceCloud', component: ServiceCloud },
    { path: '/tms', component: Tms },
    { path: '/contact', component: Contact },
    { path: '/recruit', component: Recruit },
    { path: '*', component: NotFound }
  ]
})
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
